import React from 'react';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import ReactPlayer from 'react-player';

const MovieItem = ({ 
	movie, 
	index, 
	isInMachine, 
	onRemove, 
	onAdd, 
	onTypeChange,
	movieTypeOptions 
}) => {
	const handleTypeChange = (e) => {
		if (onTypeChange) {
			onTypeChange(e, { value: e.value, id: index });
		}
	};

	const handleRemove = () => {
		if (onRemove) {
			onRemove(movie, index);
		}
	};

	const handleAdd = () => {
		if (onAdd) {
			onAdd(movie, index);
		}
	};

	console.log(movie);

	return (
		<div className="surface-0 border-round-lg border-1 border-200 overflow-hidden mb-3 shadow-1 transition-all transition-duration-200">
			

			{/* Video Container */}
			<div className="bg-black-alpha-90 flex align-items-center justify-content-center relative">
				<div className="w-full h-100% relative overflow-hidden">
					<div className="p-3 movie-header">
						<h6 className="m-0 text-300 font-normal text-sm h-5rem movie-name" title={movie.originalName || 'Unknown name'}>
							{movie.originalName || 'Unknown name'}
						</h6>
					</div>

					<ReactPlayer
						url={movie.url}
						controls
						width="100%"
						height="100%"
						config={{
							file: {
								attributes: {
									preload: 'metadata',
									disablePictureInPicture: true
								}
							}
						}}
						className="react-player"
					/>
				</div>
			</div>

			{/* Movie Controls */}
			<div className="p-3">
				<div className="flex flex-column gap-3">

					{/* Type Selection (only for machine movies) */}
					{isInMachine && (
						<div className="flex flex-column gap-2">
							<div className="flex justify-content-between align-items-center">
								<label className="text-sm font-medium text-700">Movie Type</label>
								<Button
									icon="pi pi-trash"
									severity="danger"
									size="small"
									text
									onClick={handleRemove}
									tooltip="Remove from machine"
									tooltipOptions={{ position: 'top' }}
									aria-label="Remove movie from machine"
								/>
							</div>

							<Dropdown
								value={movie.movieType}
								options={movieTypeOptions}
								onChange={handleTypeChange}
								placeholder="Select movie type"
								optionLabel="text"
								optionValue="value"
								size="small"
								className="w-full"
							/>

						</div>
					)}

					{/* Action Buttons */}
					<div className="flex gap-1 justify-content-end">
						{!isInMachine && (
							<Button
								icon="pi pi-plus-circle"
								severity="success"
								size="small"
								onClick={handleAdd}
								tooltip="Add to machine"
								tooltipOptions={{ position: 'top' }}
								aria-label="Add movie to machine"
								text
								label="Add"
							/>
						)}
					</div>
				</div>
			</div>
		</div>
	);
};

export default MovieItem;
